import React from 'react';
import B2BSignupWizard from '../B2B/B2BSignupWizard';

const EventOrganizerSignup = () => (
  <B2BSignupWizard
    profileTitle="Event Organizer Profile"
    sendOtpPath="/agency/signup/send-email-otp"
    verifyOtpPath="/agency/signup/verify-email-otp"
    submitPath="/agency/signup"
    loginPath="/associates-login"
    backPath="/signup-as"
    isValetService={false}
  />
);

export default EventOrganizerSignup;
